import { useCallback, useEffect, useState } from "react";
export const useGraphChangeNotifier = (provider) => {
    const notifyGraphChange = useCallback(() => {
        if (!provider) {
            console.warn("Provider is not available for graph change notification");
            return;
        }
        try {
            provider.awareness.setLocalStateField("graphChangeSignal", {
                type: "graph-updated",
                timestamp: Date.now(),
                clientId: provider.awareness.clientID
            });
            setTimeout(() => {
                provider.awareness.setLocalStateField("graphChangeSignal", null);
            }, 100);
        }
        catch (error) {
            console.error("Failed to notify graph change:", error);
        }
    }, [provider]);
    return notifyGraphChange;
};
export const useGraphChangeListener = (provider) => {
    const [hasExternalChanges, setHasExternalChanges] = useState(false);
    useEffect(() => {
        if (!provider) {
            return;
        }
        const handleAwarenessChange = () => {
            const states = provider.awareness.getStates();
            let externalChangeDetected = false;
            states.forEach((state, clientId) => {
                if (clientId === provider.awareness.clientID || !state.graphChangeSignal) {
                    return;
                }
                const signal = state.graphChangeSignal;
                const isRecent = Date.now() - signal.timestamp < 2000;
                if (isRecent && signal.type === "graph-updated") {
                    externalChangeDetected = true;
                }
            });
            if (externalChangeDetected && !hasExternalChanges) {
                setHasExternalChanges(true);
            }
        };
        provider.awareness.on("change", handleAwarenessChange);
        return () => {
            provider.awareness.off("change", handleAwarenessChange);
        };
    }, [provider, hasExternalChanges]);
    return [hasExternalChanges, setHasExternalChanges];
};
